import { createSlice } from "@reduxjs/toolkit";
import { getUser, loginUser } from "../../lib/useLocalStorageUser";
import { logout } from "../../../src/lib/useLocalStorageUser";

const userDetails = getUser();

const userSlice = createSlice({
	name: "user",
	initialState: userDetails ? userDetails : null,
	reducers: {
		getUser_() {},
		setUser(state, action) {
			const userData = { ...state, ...action.payload };
			userData.tokenExpirationTime = Math.floor(Date.now() / 1000) + 3600;
			loginUser(userData);
			return userData;
		},
		logoutUser(state, action) {
			const userData = action.payload;
			logout();
			return null;
		},
	},
});

export const { getUser_, setUser, logoutUser } = userSlice.actions;

export default userSlice.reducer;
